import { E as EVENTS } from './events-55e4fd80.js';

class ProductBlockVariantSelector extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      variantButton: "[js-variant-button]",
      variantGroup: "[js-variant-group-container]",
      variantLabelValue: "[js-variant-label-value]",
      variantOption: "[js-variant-option]",
      variantInput: "[js-variant-input]",
      noJsVariantSelector: "[js-no-js-variant-selector]",
    };
  }

  connectedCallback() {
    this.controller = new AbortController();

    this.initActiveVariants();

    this.addEventListener(
      EVENTS.PRODUCT_VARIANT_CHANGED,
      this.handleRepaint.bind(this),
      { signal: this.controller.signal },
    );
  }

  initActiveVariants() {
    if (this.activeVariantsController) {
      this.activeVariantsController.abort();
    }
    this.activeVariantsController = new AbortController();

    this.noJsVariantSelector = this.querySelector(
      this.selectors.noJsVariantSelector,
    );
    this.noJsVariantSelector?.remove();

    this.variantInputs = this.querySelectorAll(this.selectors.variantInput);
    this.variantInputs.forEach((input) => {
      input.addEventListener("change", this.onVariantChange.bind(this), {
        signal: this.activeVariantsController.signal,
      });
    });

    this.variantButton = this.querySelectorAll(this.selectors.variantButton);
    this.variantButton.forEach((button) => {
      button.addEventListener(
        "keydown",
        (event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();

            const swatchButton = button.getAttribute("js-swatch");
            const chipButton = button.getAttribute("js-chip");

            if (swatchButton !== null) {
              const swatchWrapper = event.target?.parentElement;
              const inputHtml = swatchWrapper?.previousElementSibling;

              this.onVariantChangeA11y(inputHtml);
            } else if (chipButton !== null) {
              this.onVariantChangeA11y(event.target?.previousElementSibling);
            }
          }
        },
        {
          signal: this.activeVariantsController.signal,
        },
      );
    });
  }

  onVariantChange(event) {
    const inputElement = event.target;
    if (!inputElement) return;

    this.variantLayout = this.getAttribute("data-variant-layout") || inputElement.dataset?.variantLayout;
    this.swatchOption = this.getAttribute("data-swatch-option");

    const variantGroup = inputElement.closest(this.selectors.variantGroup) || inputElement.parentElement?.parentElement;

    // Remove active styles from previous selections within the same group only
    switch (this.variantLayout) {
      case "chips":
        variantGroup?.querySelectorAll(".chip--selected")?.forEach(el => el.classList.remove("chip--selected"));
        inputElement.parentElement?.querySelector("[js-chip]")?.classList.add("chip--selected");
        break;

      case "swatches":
        variantGroup?.querySelectorAll(".swatch--selected")?.forEach(el => el.classList.remove("swatch--selected"));
        inputElement.parentElement?.querySelector("[js-swatch]")?.classList.add("swatch--selected");
        break;
    }

    let optionValueElement = inputElement;
    if (this.variantLayout === "dropdown" && inputElement.selectedOptions) {
      optionValueElement = inputElement.selectedOptions[0] || inputElement;
    }

    const currentMainProductSection = this.closest("[js-product-section]") || document.querySelector("[js-product-section]");
    if (!currentMainProductSection) return;

    const productWithinQuickView =
      currentMainProductSection.dataset?.sectionType === "quick-view-product";

    // Create custom event with safe parameters
    const variantChangingEvent = new CustomEvent(
      EVENTS.PRODUCT_VARIANT_CHANGING,
      {
        bubbles: true,
        composed: true,
        detail: {
          newOptionInput: optionValueElement,
          target: optionValueElement,
          withinQuickView: Boolean(productWithinQuickView),
        },
      },
    );

    currentMainProductSection.dispatchEvent(variantChangingEvent);
  }

  onVariantChangeA11y(inputHtml) {
    if (!inputHtml) return;

    const currentMainProductSection = this.closest("[js-product-section]") || document.querySelector("[js-product-section]");
    if (!currentMainProductSection) return;

    const productWithinQuickView =
      currentMainProductSection.dataset?.sectionType === "quick-view-product";

    const variantChangingEvent = new CustomEvent(
      EVENTS.PRODUCT_VARIANT_CHANGING,
      {
        bubbles: true,
        composed: true,
        detail: {
          newOptionInput: inputHtml,
          target: inputHtml,
          withinQuickView: Boolean(productWithinQuickView),
        },
      },
    );

    currentMainProductSection.dispatchEvent(variantChangingEvent);
  }

  handleRepaint() {
    this.activeVariantsController?.abort();
    this.initActiveVariants();
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.activeVariantsController?.abort();
  }
}

if (!customElements.get("product-block-variant-selector")) {
  customElements.define(
    "product-block-variant-selector",
    ProductBlockVariantSelector,
  );
}